/**
 * @title COSTCO.accertifyThreeDs.js: Feature level module
 * @description The module used for 3ds2 authentication
 * @dependency Accertify Gateway threeDS.js
 */
define([], function() {
	let accertifyThreeDS = {
		  mid: null,
		  sid: null,
		  ver: null,
		  piid: null,
		  oid: null,
		  acsDefaultSize: 'FULL_SCREEN',
		  provider: 'CREDIT_CARD',
		  cdiv: 'threedsUI',
		  dataKey: 'threeds',
		  authStatus: {AVAILABLE: 'AUTHENTICATION_AVAILABLE', SUCCESS: 'AUTHENTICATION_SUCCESSFUL'},
		  authRec: {PROCEED: 'PROCEED', NOTPROCEED: 'DO_NOT_PROCEED'},
		  authAction: {REQ: 'REQUIRED', NOTREQ: 'NOT_REQUIRED'},
		  configStatus: {SUCCESS: 'SUCCESS', FAILED: 'FAILED'},
		  apiCall: {UPDATESESSION: 'UPDATESESSSION_', CONFIG: 'CONFIGURE_',INIT: 'INITIATE_', AUTH: 'AUTHENTICATE_'},
		  errType: {JS: 'JS_ERROR', API: 'API_ERROR', EXCLUDEDCARD: 'THREEDS_EXCLUDED_CARD', AUTHCARD: 'THREEDS_AUTHENTICATED_CARD'},
		  counter: 0,
		  payerWait: 500,
		  payerRetries: 0,
		  initiateWait: 1000,
		  exclude: false,
		  configure: function() {
			  const configurePromise = new Promise(function(resolve,reject) {
				  try {
					  ThreeDS.configure({
				            merchantId: threedsData.mid,
				            sessionId: accertifyThreeDS.sid,
				            containerId: accertifyThreeDS.cdiv,
				            callback: function () {
				                if (ThreeDS.isConfigured()) {
				                	resolve();
				                } else {
				                	reject(accertifyThreeDS.apiCall.CONFIG+accertifyThreeDS.configStatus.FAILED+'|'+accertifyThreeDS.sid);
				                }
				            },
				            configuration: {
				                wsVersion: threedsData.version,
				            }
				        });
				  } catch (err) {
					  reject(accertifyThreeDS.apiCall.CONFIG+accertifyThreeDS.errType.JS+'|'+accertifyThreeDS.sid+'|'+err.message);
				  }});
			 return configurePromise;  
		  },
		  initiate: function() {
			  let orderId = $('#threedsPayment').attr('data-trans-oid');
			  let transactionId = $('#threedsPayment').attr('data-tid');
			  if((transactionId === undefined || transactionId.length == 0) && typeof Storage !== 'undefined') {
				  if (sessionStorage.getItem(accertifyThreeDS.dataKey) !== null) {
					  threedsObj = JSON.parse(sessionStorage.getItem(accertifyThreeDS.dataKey))
					  if (typeof threedsObj.tid !== 'undefined') {
						  transactionId = threedsObj.tid;
					  }
					  if (typeof threedsObj.oid !== 'undefined') {
						  orderId = threedsObj.oid;
					  }
				  }
			  }
			  if (typeof threedsData.initiateWait !== 'undefined') {
				  accertifyThreeDS.initiateWait = threedsData.initiateWait;
			  }
			  if (typeof threedsData.exclude !== 'undefined') {
				  accertifyThreeDS.exclude = threedsData.exclude;
			  }
			  let optionalParams = {};
			  const initiatePromise = new Promise (function(resolve,reject) {
				  ThreeDS.initiateAuthentication(orderId, transactionId, function (data) {
					  if (!data.error) {
						  const maskedNumber = data.restApiResponse.sourceOfFunds.provided.card.number;
						  if (accertifyThreeDS.exclude && typeof threedsData.pattern !== 'undefined' 
							  && maskedNumber.match(threedsData.pattern) !== null) {
							  reject(accertifyThreeDS.errType.EXCLUDEDCARD);
						  } else if (data.restApiResponse.response.gatewayRecommendation == accertifyThreeDS.authRec.PROCEED) {
							   setTimeout(resolve,accertifyThreeDS.initiateWait);
						  } else {
							   reject(accertifyThreeDS.apiCall.INIT+accertifyThreeDS.authRec.NOTPROCEED+'|'+orderId+'|'+transactionId);
						  }
					  } else {
						  let errMsg = '|'+orderId+'|'+transactionId+'|'+data.error.cause;
						  if (typeof data.error.explanation !== 'undefined') {
							  errMsg = errMsg+'-'+data.error.explanation;
						  }
						  reject(accertifyThreeDS.apiCall.INIT+accertifyThreeDS.errType.API+errMsg);
					  }
				  }, optionalParams); 
			  }); 
			  return initiatePromise;		  
		  },
		  authenticate: function() {
			  let acsScreenSize = threedsData !== 'undefined' 
				  && threedsData.acssize.length > 0 ? threedsData.acssize : accertifyThreeDS.acsDefaultSize;
			  let orderId = $('#threedsPayment').attr('data-trans-oid');
			  let transactionId = $('#threedsPayment').attr('data-tid');
			  let deviceIp = $('#threedsPayment').attr('data-device-ip');
			  if((transactionId === undefined || transactionId.length == 0 
					  || deviceIp === undefined || deviceIp.length == 0) && typeof Storage !== 'undefined') {
				  let threeds = sessionStorage.getItem(accertifyThreeDS.dataKey);
				  if (threeds !== undefined && threeds !== null) {
					  threedsObj = JSON.parse(threeds);
					  if (typeof threedsObj.tid !== 'undefined') {
						  transactionId = threedsObj.tid;
					  }
					  if (typeof threedsObj.oid !== 'undefined') {
						  orderId = threedsObj.oid;
					  }
					  if (typeof threedsObj.dip !== 'undefined') {
						  deviceIp = threedsObj.dip;
					  }
				  }
			  }
			  let deviceTimezone = new Date().getTimezoneOffset();
			  let billAddrObj = COSTCO.accertifyThreeDS.getBillAddress($('#OrderBillingAddressId').val());
			  let shipAddrObj = COSTCO.accertifyThreeDS.getShipAddress($('#OrderShippingAddressId').val());
			  let billCountryCode = billAddrObj['country'] == 'CA' ? 'CAN' : billAddrObj['country'] == 'US' ? 'USA' :  billAddrObj['country'];	
			  let shipCountryCode = shipAddrObj['country'] == 'CA' ? 'CAN' : shipAddrObj['country'] == 'US' ? 'USA' :  shipAddrObj['country'];
			  let sourceType =  shipAddrObj['addressType'] == 'T' ? 'NEW_ADDRESS' : 'ADDRESS_ON_FILE';
			  if (typeof threedsData.payerRetries !== 'undefined') {
				  accertifyThreeDS.payerRetries = threedsData.payerRetries;
			  }
			  if (typeof threedsData.payerWait !== 'undefined') {
				  accertifyThreeDS.payerWait = threedsData.payerWait;
			  }
			  let cardLastFour = $('input[name=ccLastFour]').val();
			  let optionalParams = {
					  "device": {
					      "browser": navigator.userAgent,
					      "hostname": location.hostname,
					      "ipAddress": deviceIp,
					      "browserDetails": {
					    	  "3DSecureChallengeWindowSize": acsScreenSize,
					    	  "acceptHeaders": "application/json",
					    	  "colorDepth": screen.colorDepth,
					    	  "javaEnabled":  navigator.javaEnabled(),
					    	  "javaScriptEnabled": true ,
					    	  "language": COSTCO.util.getLocale(),
					    	  "screenHeight": screen.height,
					    	  "screenWidth": screen.width,
					    	  "timeZone": deviceTimezone,
					      },
					  },
					  "billing":{
						  "address": {
							  "street": billAddrObj['line1'],
							  "street2": billAddrObj['line2'],
							  "company": billAddrObj['company'],
							  "city": billAddrObj['city'],
							  "stateProvince": billAddrObj['state'],
							  "postcodeZip": billAddrObj['zip'],
							  "country": billCountryCode,
						  }
					  },
					  "shipping":{
						  "address": {
							  "street": shipAddrObj['line1'],
							  "street2": shipAddrObj['line2'],
							  "company": shipAddrObj['company'],
							  "city": shipAddrObj['city'],
							  "stateProvince": shipAddrObj['state'],
							  "postcodeZip": shipAddrObj['zip'],
							  "country": shipCountryCode,
							  "source": sourceType
						  },
						  "contact": {
							  "email": shipAddrObj['email'],
							  "firstName": shipAddrObj['first'],
							  "lastName": shipAddrObj['last'],
							  "phone": shipAddrObj['phone'],
						  }
					  }
					};
			  const authenticatePromise = new Promise (function(resolve,reject){
				  ThreeDS.authenticatePayer(orderId, transactionId, function (data) {
					  	if (data.error) {
					  		if (data.error.cause == 'SERVER_BUSY' && accertifyThreeDS.counter < accertifyThreeDS.payerRetries) {
						    	accertifyThreeDS.counter = accertifyThreeDS.counter + 1;
						    	setTimeout(function() {
						    		COSTCO.accertifyThreeDS.authenticate().then(function(){resolve();
						    		}).catch(function(err) {
						    			reject(err);
						    		});},accertifyThreeDS.payerWait);
						    } else {
						    	let errMsg = '|'+orderId+'|'+transactionId+'|'+data.error.cause;
						    	if (typeof data.error.explanation !== 'undefined') {
						  			errMsg = errMsg+'-'+data.error.explanation;
					  			}
						    	reject(accertifyThreeDS.apiCall.AUTH+accertifyThreeDS.errType.API+errMsg);
						    }
					  	} else if (data.restApiResponse.response.gatewayRecommendation == accertifyThreeDS.authRec.NOTPROCEED){
					  		reject(accertifyThreeDS.apiCall.AUTH+accertifyThreeDS.authRec.NOTPROCEED+'|'+orderId+'|'+transactionId);
					  	} else if (data.restApiResponse.authentication.payerInteraction == accertifyThreeDS.authAction.REQ) {
					  		COSTCO.accertifyThreeDS.challengeLightbox(data);
					  	} else {
					  		const threedsJson = {txId: transactionId, txOrderId: orderId, supportedCard: true, 
			  						maskedCard: data.restApiResponse.sourceOfFunds.provided.card.number};
				    		$('input[name=threedsParams]').val(JSON.stringify(threedsJson));
				    		resolve();
					  	}
					}, optionalParams);
			  });	
			  return authenticatePromise;
		  },
		  initSessionData: function(currentSessionId,cardTokenized,cardNumberChanged) {
			  let cardProvider = COSTCO.CreditCard.forms.creditCardForm().find('input[name=walletProvider]').val();
			  accertifyThreeDS.sid = currentSessionId === undefined ? COSTCO.accertifyThreeDS.getSessionId() : currentSessionId;
			  let isCardTokenized = cardTokenized === undefined ? $('#iscardtokenized').val() : cardTokenized;
			  accertifyThreeDS.oid = $('#threedsPayment').data("trans-oid");
			  if (accertifyThreeDS.oid === undefined && typeof Storage !== 'undefined' 
				  && sessionStorage.getItem(accertifyThreeDS.dataKey) !== null) {
				  const threedsObj = JSON.parse(sessionStorage.getItem(accertifyThreeDS.dataKey));
				  accertifyThreeDS.oid = threedsObj.oid;
			  }
			  let cardUpdated = cardNumberChanged !== undefined ? cardNumberChanged : false;
			  let cardMemberRefId = $('input[name=autoRenewCardRefId]').length > 0 ? $('input[name=autoRenewCardRefId]').val() : '';
			  let cardMemberId = $('input[name=autoRenewMemberId]').length > 0 ? $('input[name=autoRenewMemberId]').val() : '';
			  let cardRefId = COSTCO.CreditCard.forms.creditCardForm().find('input[name=xCreditCardId]').val();
			  let cardExpiredMonth = '';
			  let cardExpiredYear = '';
			  if ($('input[name=cc_expiry_date]').length > 0) {
				  let expiredDate = $('input[name=cc_expiry_date]').val();
				  const arrExpiredDate = expiredDate.split('/');
				  cardExpiredMonth = arrExpiredDate[0];
				  if (arrExpiredDate[1] !== undefined) {
					  cardExpiredYear = arrExpiredDate[1];
				  }
			  }
			  let cardHolderName = $('input[name=cc_nameoncard]').length > 0 ? $('input[name=cc_nameoncard]').val() : '';
			  let requestData = {
					threeDSAuthentication: true,
					sessionId: accertifyThreeDS.sid,
					walletProvider: cardProvider.length > 0 ? cardProvider : accertifyThreeDS.provider,
					piId: $('#threedsPayment').attr('data-piid'),
					cardTokenized: isCardTokenized,
					orderId: $('#threedsPayment').attr('data-oid'),
					currencyCode: threedsData.currency,
					amount: $('#outstandingPrincipal').val(),
					deviceJavaEnabled: navigator.javaEnabled(),
					redirectParams: COSTCO.accertifyThreeDS.getRedirectParams(),
					redirectResponseUrl: COSTCO.accertifyThreeDS.getRedirectUrl(),
					cardUpdated: cardUpdated,
					cardRefId: cardRefId,
					cardMemberRefId: cardMemberRefId,
					cardMemberId: cardMemberId,
					maskedCard: $('#account_validator').val(),
					cardExpiredMonth: cardExpiredMonth,
					cardExpiredYear: cardExpiredYear,
					cardHolderName: cardHolderName,
			  }
			  return requestData;
		  },
		  updateSession: function(requestData) {
			  const sessionPromise = new Promise (function(resolve,reject) {
				  COSTCO.util.ajax({
			        url: 'AjaxUpdateSessionEnterprisePayment',
			        method: 'POST',
			        dataType: 'json',
			        data: requestData,
			        done: function(data, textStatus, jqXHR, options) {
			        	if (data.status == undefined || data.status == 'error') {
			        		reject(accertifyThreeDS.apiCall.UPDATESESSION+
			        				accertifyThreeDS.configStatus.FAILED+'|'+requestData.sessionId);
			        	} else if (data.cardExclusion) {
			        		reject(accertifyThreeDS.errType.EXCLUDEDCARD);
			        	} else if (data.cardAuthenticated) {
			        		let threedsUpdate = {txId: data.transactionId, txOrderId: data.transactionOrderId, supportedCard: true, 
		        				maskedCard: data.maskedCard, authenticated: true};
			        		$('input[name=threedsParams]').val(JSON.stringify(threedsUpdate));
				    		if (typeof Storage !== 'undefined') {
				    			let encodedNum = COSTCO.util.encode(data.maskedCard);
				        		threedsUpdate = {tid: data.transactionId, oid: data.transactionOrderId, supportedCard: true, 
				        				mc: encodedNum, authenticated: true};
		                		sessionStorage.setItem(accertifyThreeDS.dataKey, JSON.stringify(threedsUpdate));
		                	}
			        		reject(accertifyThreeDS.errType.AUTHCARD);
			        	} else {
			        		$('#threedsPayment').attr('data-tid',data.transactionId);
			        		$('#threedsPayment').attr('data-device-ip',data.deviceIpAddress);
			        		$('#threedsPayment').attr('data-trans-oid',data.transactionOrderId);
			        		if (typeof Storage !== 'undefined') {
			        			let encodedSessionId = COSTCO.util.encode(requestData.sessionId);
		                		const respObj = { sid: encodedSessionId, oid: data.transactionOrderId, 
		                				tid: data.transactionId, dip:data.deviceIpAddress};
		                		sessionStorage.setItem(accertifyThreeDS.dataKey, JSON.stringify(respObj));
		                	}
			        		resolve();
			        	}
			        },
			      });
			  });
			  return sessionPromise;
		  },
		  onInitLoad: function() {
			  if (COSTCO.accertifyThreeDS.isCardSupported()){
				  let callInitConfig = true;
				  accertifyThreeDS.sid = COSTCO.accertifyThreeDS.getSessionId();
				  if (typeof Storage !== 'undefined' && sessionStorage.getItem(accertifyThreeDS.dataKey) !== null) {
					  const threedsInitLoadObj = JSON.parse(sessionStorage.getItem(accertifyThreeDS.dataKey));
					  if (threedsInitLoadObj.sid !== undefined) {
						  let decodedSessionId = COSTCO.util.decode(threedsInitLoadObj.sid);
						  
						  if (accertifyThreeDS.sid == decodedSessionId) {
							 callInitConfig = false;
						  }
					  } else if (threedsInitLoadObj.cardAuthenticated !== undefined && threedsInitLoadObj.cardAuthenticated) {
						  let mc = COSTCO.util.decode(threedsInitLoadObj.mc);
						  let acc = $('#account_validator').val();
						  if (acc.startsWith('*')){
							  acc = acc.substring(acc.length-4);
							  mc = mc.substring(mc.length-4);
						  }
						  if (acc === mc) {
							  callInitconfig = false; 
						  }
					  }
				  }
				  if (callInitConfig) {
					  COSTCO.accertifyThreeDS.initConfig(accertifyThreeDS.sid);
				  }
			  }
		  },
		  initConfig: function(currentSessionId) {
			  let initData = COSTCO.accertifyThreeDS.initSessionData(currentSessionId);
			  return COSTCO.accertifyThreeDS.updateSession(initData).then(function(){
				  return COSTCO.accertifyThreeDS.configure();
			  }).then(function() {
				  return COSTCO.accertifyThreeDS.initiate();
			  }).catch(function(err) {
				  err = COSTCO.accertifyThreeDS.getErrorString(err);
				  if (err !== accertifyThreeDS.errType.AUTHCARD) {
					  $('input[name=threedsParams]').val(JSON.stringify({sid: currentSessionId, supportedCard: true, errorCode: err}));
					  if (typeof Storage !== 'undefined') {
						  if (sessionStorage.getItem(accertifyThreeDS.dataKey) !== null) {
							  COSTCO.accertifyThreeDS.removeStorageSession();
						  }
						  let encodedSessionId = COSTCO.util.encode(currentSessionId);
						  const threedsInitError = {sid: encodedSessionId, supportedCard: true, errorCode: err};
						  sessionStorage.setItem(accertifyThreeDS.dataKey, JSON.stringify(threedsInitError));
					  }
			  		}
			  });
		  },		  
		  processAuthentication: function(cardNumberChanged) {
			  let cardTokenized = true;
			  let currentSessionId = '';
			  if (cardNumberChanged !== undefined && cardNumberChanged === 'true') {
				  currentSessionId = $('input[name=tkResSessionIdCapture]').val();
				  cardTokenized = false;
			  } else {
				  currentSessionId = COSTCO.accertifyThreeDS.getSessionId();
				  cardTokenized = $('#iscardtokenized').length > 0 ? $('#iscardtokenized').val() : false;
				  cardNumberChanged = false;
			  }
			  let currentTransactionId = $('#threedsPayment').attr("data-tid");
			  let threedsConfig = true;
			  let sessionChanged = false;
			  if(typeof Storage !== 'undefined') {
				  let threedsStorageData = sessionStorage.getItem(accertifyThreeDS.dataKey);
				  if (threedsStorageData !== undefined && threedsStorageData !== null ) {
					  let threedsDataObj = JSON.parse(threedsStorageData);
					  if ((currentTransactionId === undefined || currentTransactionId.length == 0)
						  && typeof threedsDataObj.tid !== 'undefined') {
						  currentTransactionId = threedsDataObj.tid;
						  threedsConfig = false;
					  }
					  if (threedsDataObj.sid !== undefined) {
						  let prevSessionId = COSTCO.util.decode(threedsDataObj.sid);
						  if (currentSessionId !== prevSessionId) {
							  sessionChanged = true;
						  }
					  }
				  } 
			  }
			  if (cardNumberChanged || sessionChanged || (currentTransactionId === undefined || currentTransactionId.length == 0)) {
				  let currentSessionData = COSTCO.accertifyThreeDS.initSessionData(currentSessionId,cardTokenized,cardNumberChanged);
				  return COSTCO.accertifyThreeDS.updateSession(currentSessionData).then(function(){
					  return COSTCO.accertifyThreeDS.configure();
				  }).then(function() {
					  $('.order-ajax').addClass('ajax-busy');
					  return COSTCO.accertifyThreeDS.initiate();
				  }).then(function() {
					  return COSTCO.accertifyThreeDS.authenticate();
				  });
			  } else if (threedsConfig) {
				  return COSTCO.accertifyThreeDS.authenticate();
			  } else {
				  return COSTCO.accertifyThreeDS.configure().then(function() {
					  return COSTCO.accertifyThreeDS.authenticate();
				  });
			  }
			  
		  },
		  isEnabled: function() {
			  if((typeof costcoStoreFeatures.ACCERTIFY_3DS_ENABLED !== 'undefined' && costcoStoreFeatures.ACCERTIFY_3DS_ENABLED) 
					  || (typeof accertify3DSEnabled !== 'undefined' && accertify3DSEnabled)) {
				  return true;
			  } else {
				  return false;
			  }
		  },
		  isCardSupported: function(cardType) {
			  let cardSupported = false;
			  if (typeof threedsPayment !== 'undefined' && typeof threedsData !== 'undefined') {
				  let paymentCard = cardType !== undefined && cardType.length > 0 ? cardType.replace(' ','') : $('#threedsPayment').data("card-network");
				  if (threedsData.cards.indexOf(paymentCard.toUpperCase()) >= 0) {
					  cardSupported = true;
				  }
			  }
			  return cardSupported;
		  },
		  getSessionId: function() {
			  return typeof modularTokenSessionId !== 'undefined' ? modularTokenSessionId : $('#creditCardTokenSessionId').val();
		  },
		  removeStorageSession: function() {
			if (typeof Storage !== 'undefined' && sessionStorage.getItem(accertifyThreeDS.dataKey) !== null) {
          		sessionStorage.removeItem(accertifyThreeDS.dataKey);
          	}
		  },
		  challengeLightbox: function(data) {
			  let threedsModal = '<div class="modal fade" id="threedsUI" tabindex="-1" style="display: none;position:fixed; top:50%; left:50%;transform:translate(-50%, -50%);" role="dialog"></div>';
			  let resp = $(threedsModal).append(data.htmlRedirectCode);
			  $(resp).modal({
				  overlayClose:true,
				  show:true,
			  });
		  },
		  getRedirectParams: function(){
			  let formId = typeof threedsPlaceOrder !== 'undefined' && $('#threedsPlaceOrder').val() === 'true' ? 'CheckoutPaymentForm' : 'CheckoutReviewForm';
			  if (checkoutPage !== 'undefined' && checkoutPage.indexOf('quick-membership') != -1) {
				  formId = 'CheckoutMembership';
			  }
			  return '[formId?'+formId+']';
		  },
		  getRedirectUrl: function(){
			  return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/ThreedsChallengeHandler?';
		  },
		  getShipAddress: function(addressId) {
			  return window['ajaxAddressObject_' + addressId];
		  },
		  getBillAddress: function(addressId) {
			  return window['ajaxBillAddressObject_' + addressId];
		  },
		  hasPreProcessError: function() {
			  let hasError = false;
			  let threedsParamJson = $('input[name=threedsParams]').val();
			  if ((threedsParamJson === undefined || threedsParamJson.length == 0) && typeof Storage !== 'undefined' 
					 && sessionStorage.getItem(accertifyThreeDS.dataKey) !== null) {
					 threedsParamJson = sessionStorage.getItem(accertifyThreeDS.dataKey);
			  }
			  if (threedsParamJson !== undefined && threedsParamJson.length > 0) {
				  let threedsParamObj = JSON.parse(threedsParamJson); 
				  if (typeof threedsParamObj.errorCode !== 'undefined' && threedsParamObj.errorCode.length > 0) {
					  $('input[name=threedsParams]').val(JSON.stringify({supportedCard: true, errorCode: threedsParamObj.errorCode}));
					  hasError = true;
				  } else if (typeof threedsParamObj.authenticated !== 'undefined' && threedsParamObj.authenticated) {
					  let mcn = '';
					  let txid = '';
					  let txoid = '';
					  if (typeof threedsParamObj.maskedCard !== 'undefined') {
						  mcn = threedsParamObj.maskedCard;
						  txid = threedsParamObj.txId;
						  txoid = threedsParamObj.txOrderId;
					  } else if (typeof threedsParamObj.mc !== 'undefined') {
						  mcn = COSTCO.util.decode(threedsParamObj.mc);
						  txid = threedsParamObj.tid;
						  txoid = threedsParamObj.oid;
					  }
					  let cardNum = mcn;
					  let acc = $('#account_validator').val();
					  if (acc.startsWith('*')){
						  acc = acc.substring(acc.length-4);
						  mcn = mcn.substring(mcn.length-4);
					  }
					  if (acc === mcn) {
						  $('input[name=threedsParams]').val(JSON.stringify(
								  {txId: txid, txOrderId: txoid, supportedCard: true, maskedCard: cardNum, authenticated: true}));
						  hasError = true;
					  }
				  }
			  }
			  return hasError;
		  },
		  getErrorString : function(result) {
			  if (typeof result.error !== 'undefined') {
				  let errMsg = 'Error:';
				  if (typeof result.error.cause !== 'undefined') {
					  errMsg = errMsg + result.error.cause;
				  }
				  if (typeof result.error.explanation !== 'undefined') {
					  errMsg = errMsg + result.error.explanation;
				  } 
				  if (typeof result.error.field !== 'undefined') {
					  errMsg = errMsg + result.error.field;
				  }
				  result = errMsg;
			  } else if (typeof result === 'undefined') {
				  result = 'UndefinedError';
			  }
			  return result;
		  },
		  
  }

  // Expose accertifyThreeDS to the global scope.
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = new Object();
  }

  window.COSTCO.accertifyThreeDS = accertifyThreeDS;

  return accertifyThreeDS;
});


// WEBPACK FOOTER //
// ./js/checkout/accertify.threeds.js